import axios from 'axios';
import { NODE_URL } from '../config/env.variable';

const axiosInstance = axios.create({
  baseURL: NODE_URL,
});

export default axiosInstance;
